(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["family-shirt-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  const CLOUD_NAME    = 'dwdxw56k5';
  const UPLOAD_PRESET = 'buffasian_kamon';

  const initFamilyShirtForm = (container) => {
    const form        = container.querySelector('form');
    const submitBtn   = container.querySelector('#shirt-form-submit');
    const ackCheckbox = container.querySelector('#FamilyShirtForm-ack');

    // Acknowledgment gate
    ackCheckbox?.addEventListener('change', () => {
      submitBtn.disabled = !ackCheckbox.checked;
    });

    // Color card selection
    const colorBtns  = container.querySelectorAll('.ba-color-btn');
    const colorInput = container.querySelector('#shirt-color-input');
    colorBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        colorBtns.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        if (colorInput) colorInput.value = btn.getAttribute('data-color');
      });
    });

    // Kamon radio → show/hide upload area
    const kamonRadios = container.querySelectorAll('[data-kamon-upload]');
    const uploadArea  = container.querySelector('#kamon-upload-area');
    kamonRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!uploadArea) return;
        uploadArea.style.display = radio.getAttribute('data-kamon-upload') === 'show' ? 'block' : 'none';
      });
    });

    // Youth toggle buttons
    const toggleBtns   = container.querySelectorAll('.ba-toggle-btn');
    const youthSection = container.querySelector('#youthSection');
    const youthHidden  = container.querySelector('#youth-sizes-value');
    toggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const show = btn.getAttribute('data-youth') === 'show';
        toggleBtns.forEach(b => b.classList.remove('ba-toggle-btn--active'));
        btn.classList.add('ba-toggle-btn--active');
        youthSection?.classList.toggle('open', show);
        if (youthHidden) youthHidden.value = show ? 'Yes' : 'No';
      });
    });

    // File input — local preview only, upload happens on submit
    const uploadTrigger    = container.querySelector('#kamon-upload-trigger');
    const fileInput        = container.querySelector('#kamon-file-input');
    const imageUrlInput    = container.querySelector('#kamon-image-url');
    const previewContainer = container.querySelector('#kamon-upload-preview');
    let selectedFiles      = [];

    uploadTrigger?.addEventListener('click', () => fileInput?.click());

    fileInput?.addEventListener('change', (e) => {
      Array.from(e.target.files).forEach(file => {
        selectedFiles.push(file);

        const wrapper = document.createElement('div');
        wrapper.style.cssText = 'position:relative;width:80px;flex-shrink:0;';

        const img = document.createElement('img');
        img.alt = 'Preview';
        img.style.cssText = 'width:80px;height:80px;object-fit:cover;border-radius:3px;border:1px solid #2a2020;display:block;';

        const reader = new FileReader();
        reader.onload = (ev) => { img.src = ev.target.result; };
        reader.readAsDataURL(file);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.textContent = '✕';
        removeBtn.style.cssText = 'position:absolute;top:3px;right:3px;width:18px;height:18px;border-radius:50%;background:#b41e1e;color:#fff;border:none;cursor:pointer;font-size:10px;display:flex;align-items:center;justify-content:center;padding:0;line-height:1;';
        removeBtn.addEventListener('click', () => {
          selectedFiles = selectedFiles.filter(f => f !== file);
          previewContainer.removeChild(wrapper);
        });

        wrapper.appendChild(img);
        wrapper.appendChild(removeBtn);
        previewContainer.style.cssText = 'display:flex;flex-wrap:wrap;gap:0.5rem;margin-top:0.75rem;';
        previewContainer.appendChild(wrapper);
      });
      fileInput.value = '';
    });

    // On submit — upload files to Cloudinary first, then submit form
    form?.addEventListener('submit', async (e) => {
  if (selectedFiles.length === 0) return;

  e.preventDefault();

  const originalText = submitBtn.textContent;
  submitBtn.textContent = 'Uploading images…';
  submitBtn.disabled = true;

  try {
    const urls = await Promise.all(
      selectedFiles.map(async (file) => {
        const data = new FormData();
        data.append('file', file);
        data.append('upload_preset', UPLOAD_PRESET);
        const res  = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: 'POST', body: data });
        const json = await res.json();
        return json.secure_url;
      })
    );

    if (imageUrlInput) imageUrlInput.value = urls.join(', ');
    selectedFiles = [];
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  } catch (err) {
    console.error('Upload failed:', err);
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
    alert('Image upload failed. Please check your connection and try again.');
  }
});

  };

  document.querySelectorAll('.ba-shirt-section').forEach(initFamilyShirtForm);
  document.addEventListener('shopify:section:load', (e) => {
    const c = e.target.querySelector('.ba-shirt-section');
    if (c) initFamilyShirtForm(c);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
